import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getTransactions } from "../utils/Api/ApiCalls";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";

const Transactions = () => {
	const [transactionData, setTransactionData] = useState([]);
	const itemsPerPage = 5;

	const [searchTerm, setSearchTerm] = useState("");
	const [temp, setTemp] = useState([]);

	// Here we use item offsets; we could also use page offsets
	// following the API or data you're working with.
	const [itemOffset, setItemOffset] = useState(0);

	// Simulate fetching items from another resources.
	// (This could be items from props; or items loaded in a local state
	// from an API endpoint with useEffect and useState)
	const endOffset = itemOffset + itemsPerPage;
	let currentItems = transactionData?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(transactionData?.length / itemsPerPage);

	// Invoke when user click to request another page.
	const handlePageClick = (event) => {
		const newOffset = (event.selected * itemsPerPage) % transactionData.length;
		setItemOffset(newOffset);
	};

	useEffect(() => {
		getAllTransactions();
	}, []);
	const getAllTransactions = async () => {
		try {
			const response = await getTransactions();
			setTransactionData(response?.transactions);
			setTemp(response?.transactions);
			
		} catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
	};
	const handleSearchChange = (event) => {
		setSearchTerm(event.target.value);
	};

	const onSearch = () => {
		
		
		
		let data = temp.filter((item, i) => item.Amount.toString().includes(searchTerm) || item.PaymentMethod.includes(searchTerm));

		setTransactionData(data);
	}
	return (
		<section class='content-main'>
			<div class='content-header'>
				<h2 class='content-title'>Transactions</h2>
			</div>
			<div class='card'>
				<div class='card-body'>
					<div class='row'>
						<div class='col-md-12'>
							<header class='border-bottom mb-4 pb-4'>
								<div class='row'>
									<div class='col-lg-5 col-6 me-auto'>
										<input
											type='text'
											placeholder='Search by Amount, payment method.'
											class='form-control'
											value={searchTerm} onChange={handleSearchChange} onKeyUp={onSearch}

										/>
									</div>
									<div class='col-lg-2 col-6'>
										{/* <select class='form-select'>
											<option>Method</option>
											<option>Master card</option>
											<option>Visa card</option>
											<option>Paypal</option>
										</select> */}
									</div>
								</div>
							</header>

							<div class='table-responsive'>
								<table class='table table-hover'>
									<thead>
										<tr>
											<th>Transaction ID</th>
											<th>Amount</th>
											<th>Payment Method</th>
											<th>Transaction Date</th>
											<th class='text-end'>Action</th>
										</tr>
									</thead>
									<tbody>
										{
											currentItems?.length > 0 ?
												currentItems?.map((item, i) => <tr key={"transaction" + i}>
													<td>
														<b>{item.TransactionId}</b>
													</td>
													<td>₦{parseFloat(item.Amount.toString().substr(0, item.Amount.toString().length - 2)).toLocaleString()}</td>
													<td>
														{/* <div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/1.png'
														alt='Payment'
													/>
													<span class='text text-muted'>{item.PaymentMethod}</span>
												</div> */}
														{toProperCase(item.PaymentMethod)}
													</td>
													<td>{new Date(item.TransactionDate).toDateString()}</td>
													<td class='text-end'>
														<Link
															to={`/transaction/details/${item.TransactionId}`}
															class='btn btn-sm btn-light font-sm rounded'>
															Details
														</Link>
													</td>
												</tr>) : <tr>No transaction</tr>
										}
										{/* <tr>
											<td>
												<b>#456667</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/1.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Amex</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#134768</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/2.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Master card</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#134768</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/3.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Paypal</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#134768</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/4.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Visa</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#887780</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/4.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Visa</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#344556</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/4.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Visa</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#134768</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/2.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Master card</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#134768</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/2.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Master card</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#998784</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/3.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Paypal</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#556667</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/3.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Paypal</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#098989</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='assets/imgs/card-brands/3.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Paypal</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr>
										<tr>
											<td>
												<b>#134768</b>
											</td>
											<td>$294.00</td>
											<td>
												<div class='icontext'>
													<img
														class='icon border'
														src='/assets/imgs/card-brands/4.png'
														alt='Payment'
													/>
													<span class='text text-muted'>Visa</span>
												</div>
											</td>
											<td>16.12.2020, 14:21</td>
											<td class='text-end'>
												<a
													href='#'
													class='btn btn-sm btn-light font-sm rounded'>
													Details
												</a>
											</td>
										</tr> */}
									</tbody>
								</table>
							</div>
						</div>

						{/* <aside class='col-lg-3'>
							<div class='box bg-light' style = {{minHeight: "80%"}}>
								<h6 class='mt-15'>Transaction Details</h6>
								<hr />
								<h6 class='mb-0'>Suplier:</h6>
								<p>TemplateMount</p>
								<br />
								<h6 class='mb-0'>Date:</h6>
								<p>December 19th, 2020</p>
								<br />
								<h6 class='mb-0'>Billing address</h6>
								<p>1901 Thornridge Cir. Shiloh, Hawaii 81063</p>
								<br />
								<h6 class='mb-0'>VAT ID:</h6>
								<p>54741654160</p>
								<br />
								<h6 class='mb-0'>Email:</h6>
								<p>support@example.com</p>
								<br />
								<h6 class='mb-0'>Item purchased:</h6>
								<br />
								<p>
									<a href='#'>
										Adidas Air Jordan{" "}
										<i class='icons material-icons md-launch'></i>
									</a>
									<br />
									<a href='#'>
										{" "}
										Great product <i class='icons material-icons md-launch'></i>{" "}
									</a>
								</p>
								<br />
								<p>Payment: PayPal</p>
								<p class='h4'>$457.14</p>
								<hr />
								<a class='btn btn-light' href='#'>
									{" "}
									Download receipe{" "}
								</a>
							</div>
						</aside> */}
					</div>
				</div>
			</div>

			<div class='pagination-area mt-30 mb-50'>
				<nav aria-label='Page navigation example'>
					<ReactPaginate
						nextLabel="Next"
						onPageChange={handlePageClick}
						pageRangeDisplayed={3}
						marginPagesDisplayed={2}
						pageCount={pageCount}
						previousLabel="Previous"
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousClassName="page-item"
						previousLinkClassName="page-link w-auto"
						nextClassName="page-item"
						nextLinkClassName="page-link w-auto"
						breakLabel="..."
						breakClassName="page-item"
						breakLinkClassName="page-link"
						containerClassName="pagination justify-content-start"
						activeClassName="active"
						renderOnZeroPageCount={null}
					/>
				</nav>
			</div>
		</section>
	);
};

export default Transactions;


const toProperCase = (text) => {
	return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
};